import * as types from '@/store/mutation-types'
import api from '@/services/api/adminSocial'
import { handleError } from '@/utils/utils.js'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'

const getters = {
  tripData: state => state.tripData,
  googleData: state => state.googleData
}

const actions = {
  getTripInfo({ commit }, identity) {
    checkIfTokenNeedsRefresh()
    commit(types.SHOW_TOP_LOADING, true)
    return new Promise((resolve, reject) => {
      api
        .getTripInfo(identity)
        .then(response => {
          if (response.status === 200) {
            commit(types.TRIPDATA, response.data)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
          }
        })
        .catch(error => {
          commit(types.SHOW_TOP_LOADING, false)
          handleError(error, commit, reject)
        })
    })
  },
  getGoogleInfo({ commit }, identity) {
    checkIfTokenNeedsRefresh()
    commit(types.SHOW_TOP_LOADING, true)
    return new Promise((resolve, reject) => {
      api
        .getGoogleInfo(identity)
        .then(response => {
          if (response.status === 200) {
            commit(types.GOOGLEDATA, response.data)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
          }
        })
        .catch(error => {
          commit(types.SHOW_TOP_LOADING, false)
          handleError(error, commit, reject)
        })
    })
  }

}

const mutations = {
  [types.TRIPDATA](state, data) {
    state.tripData = data
  },
  [types.GOOGLEDATA](state, data) {
    state.googleData = data
  }
}

const state = {
  tripData: [],
  googleData: []
}

export default {
  state,
  getters,
  actions,
  mutations
}
